export default {
  approvalLevels: ["Passive", "PreTrip", "None"],
  expiryMonths: [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ],
  expiryYears: [
    "2016",
    "2017",
    "2018",
    "2019",
    "2020",
    "2021",
    "2022",
    "2023",
    "2024",
    "2025",
    "2026",
    "2027",
    "2028",
    "2029",
    "2030",
    "2031",
    "2032",
    "2033",
    "2034",
    "2035",
    "2036",
    "2037",
    "2038",
    "2039",
    "2040",
    "2041",
    "2042",
    "2043",
    "2044",
    "2045",
    "2046",
    "2047",
    "2048",
    "2049",
    "2050",
    "2051",
    "2052",
    "2053",
    "2054",
    "2055",
    "2056",
    "2057",
    "2058",
    "2059",
    "2060",
    "2061",
    "2062",
    "2063",
    "2064",
    "2065",
    "2066",
    "2067",
    "2068",
    "2069",
    "2070",
    "2071",
    "2072",
    "2073",
    "2074",
    "2075",
    "2076",
    "2077",
    "2078",
    "2079",
    "2080",
    "2081",
    "2082",
    "2083",
    "2084",
    "2085",
  ],
  cardType: [
    {
      label: "Visa",
      value: "VI",
    },
    {
      label: "American Express",
      value: "AX",
    },
    {
      label: "BC Card",
      value: "BC",
    },
    {
      label: "MasterCard",
      value: "CA",
    },
    {
      label: "Discover",
      value: "DS",
    },
    {
      label: "Diners Club",
      value: "DC",
    },
    {
      label: "Carta Si",
      value: "T",
    },
    {
      label: "Carte Bleue",
      value: "R",
    },
    {
      label: "Visa Electron",
      value: "E",
    },
    {
      label: "Japan Credit Bureau",
      value: "JC",
    },
    {
      label: "Maestro",
      value: "TO",
    },
    {
      label: "AirPlus Card",
      value: "TP",
    },
  ],
  SegmentTypes: ["Flight", "Rail", "Car", "Hotel", "GroundTransport"],
  SectionType: ["Summary", "UserHold", "Exchange"],
  AirlinePolicyTypes: ["PreferredCarriers", "ShowAll"],
  FlightFlyAmericaPolicyType: [
    "NotEnabled",
    "EnforceCompliance",
    "EnforceComplianceNoOpenSkies",
    "ShowButNotEnforce",
  ],
  HotelApplyVirtualCreditCardTypes: [
    {
      label: "Use agency VCC config", 
      value: "UseagencyVCCconfig"
    }, 
    {
      label: "Optional", 
      value: "Optional" 
    }, 
    {
      label: "Mandatory", 
      value: "Mandatory" 
    },
    {
      label: "Disabled", 
      value: "Disabled" 
    }
  ],
  HotelPolicyTypes: ["ShowOnlyPreferred", "PreferredFirst"],
  HotelPerNightRateDisplayTypes: [
    {
      label: "Highest", 
      value: "Highest"
    }, 
    {
      label: "Average", 
      value: "Average" 
    }
  ],
  HotelRateCategoriesCategories: ["Government", "Military", "Travel Industry", "Contract Rates"],
  HotelRateCategoriesPriorities: ["No priority", "No priority, but show on initial results", "Always display first", "Always display first regardless of Sort or Filter"],
  HotelExcludedAggregatorChainsAggregators: ["Booking.com", "Expedia"],
  SettingsHotelPreferredTagsSourceType: ["None", "UseFlagInGDSResponse", "UseHotelDatabaseConfig"],
  DebtorHotelPreferredTagsSourceType: ["SystemSettings", "UseFlagInGDSResponse", "UseHotelDatabaseConfig"],
  DebtorHotelConfigTagsToIgnoreFromDatabaseSourceType: ["SystemSettings", "Customize"],
  PerDiemMappingsTypes: ["Country", "City", "County"],
  UnusedTicketProviderTypes: [
    "Sabre Profile",
    "Elysian Towers",
    "Banx",
    "Southwest Direct RTF",
  ],
  VendorPreferenceRangeValues: [
    -5, 5
  ],
  ItineraryValidatorTypes: [
    "SegmentError",
    "ChurningActions",
    "DuplicateTrips",
    "ShoppingCartDuplicateSegment",
    "CompanyReferenceValidator",
  ],
  FlightTypes: ["Single", "Return"],
  PriceToleranceType: ["Amount", "Percentage"],
  GdsFareSearchGroupType: ["Individual", "Bundled"],
  GdsFareSearchSearchType: [
    "Unknown",
    "Branded",
    "NonBranded",
    "BrandedSingleFares",
    "BrandedMultipleFares",
    "BrandedOneWay",
    "BrandedSingleFaresOneWay",
    "BrandedMultipleFaresOneWay",
  ],
  GDSProviders: [
    "Expedia",
    "Sabre",
    "SabreNdc",
    "Flight Booking Engine",
    "Jetstar",
    "Rex",
    "Travelfusion",
    "AgentWare",
    "Conferma",
    "EventsAir",
    "FareLogix",
    "Groundspan",
    "Amadeus",
  ],
  GDSProvidersPrimary:[
    "Sabre",
    "Amadeus"
  ],
  HotelRateTypes: [
    "Government",
    "Military",
    "Travel Industry",
    "Other Sabre Rates",
    "Booking.com",
    "Expedia",
  ],
  HotelConfigurationRadius: [
    {
      label: "N/A",
      value: null,
    },
    {
      label: "2",
      value: 2,
    },
    {
      label: "5",
      value: 5,
    },
    {
      label: "10",
      value: 10,
    },
    {
      label: "15",
      value: 15,
    },
    {
      label: "25",
      value: 25,
    },
    {
      label: "50",
      value: 50,
    },
    {
      label: "100",
      value: 100,
    },
  ],
  RadiusOptions: [
    {
      label: "2",
      value: 2,
    },
    {
      label: "5",
      value: 5,
    },
    {
      label: "10",
      value: 10,
    },
    {
      label: "15",
      value: 15,
    },
    {
      label: "25",
      value: 25,
    },
    {
      label: "50",
      value: 50,
    },
    {
      label: "100",
      value: 100,
    },
  ],
  TravellerConfigurationSources: [
    {
      label: "Tramada",
      value: "Tramada",
    },
    {
      label: "Sabre",
      value: "Sabre",
    },
  ],
  PaymentTypes: ["Invoice"],
  SectorTypes: ["Flight", "Rail", "Hotel", "Car", "GroundTransport"],
  PolicyTypes: ["Include", "Exclude"],
  CompanyReferencesFlags: [
    "GuestTravellerTrue",
    "GuestTravellerFalse",
    "FlightInPolicy",
    "FlightOutPolicy",
    "HotelInPolicy",
    "HotelOutPolicy",
    "CarInPolicy",
    "CarOutPolicy",
    "RailInPolicy",
    "RailOutPolicy",
    "InternationalFalse",
		"InternationalTrue"
  ],
    GDSSettingsOptions: [
      "AvailableCities",
      "VehicleCodes",
      "QuoteCurrency",
      "AvailableCountries",
      "Identifier",
      "ExcludedCarriers",
      "ExcludedOperatingCarriers",
      "DisableAggregators",
      "AdditionalFareCodeRequests",
      "DiversityPercentage",
      "DiversityLowFareBucketOptions",
      "DiversityLowFareBucketFareCutOff",
      "DiversityPriceWeight",
      "DiversityTravelTimeWeight",
      "DiversityTimeOfDayWeight",
      "DiversityStopsNumberWeight",
      "DiversityTimeWindowHours",
      "DiversityTimeWindowPercentage",
      "DiversityOperatingDuplicateWeight",
      "DiversityCarrierPreferenceWeight",
      "DiversityCarrierPreferenceOnline",
      "DiversityCarrierPreferenceDefaultOptions",
      "DiversityInboundOutboundPairingWeight",
      "DiversityInboundOutboundPairingDuplicates",
      "DiversitySetDiversityParameters",
      "FinishingRemarks",
      "Username",
      "Password",
      "AgentLogin-",
      "AgentPassword-",
      "SourceOrganization",
      "ServiceTag",
      "RailItineraryCount",
      "FlightItineraryCount",
      "SouthwestAccountNumber",
      "ClientId",
      "PaidSeatsEnabled",
      "EventId",
      "OnlineIndicator",
      "IncludePenaltyInfo",
      "SeparatePnrCarriers",
      "WritePassiveFightSegment",
      "IncludePreferredCarriersInMainSearch",
      "CarriersExcludePricingFareBasisCodes",
      "PassiveFlightSegmentOthTemplate",
      "RepriceDisableAlternateFareShopping",
      "CarLocationDefaultRadius",
      "UnusedTickets",
      "BFMSearchV2",
      "BFMVersion6",
      "BFMSearchV2DistinctCarriers",
      "BFMSearchV2DistinctCabins",
      "BFMPreferredCarrierDedicatedSearch",
      "BFMRefundabledDedicatedSearch",
      "BFMUnbrandedDedicatedSearch",
      "NotAllowUnusedTicket",
      "CorporateCode",
      "RepriceCombinableThresholdAmount",
      "MyBookingsLive",
      "AirBookRetryRebook",
      "AirPriceSmartPriceV2",
      "AirPriceAcceptablePriceIncrease",
      "AirPriceAcceptablePriceDecrease",
      "AirPriceDisableBrandCode",
      "SplitTicketingCarriers",
      "HotelShopKeyEnabled",
      "HotelShopKeyMaxCalls",
      "HotelBookGDSviaCSL",
      "HotelRateKeyEnabled",
      "EnableModifyBookingForBookingDotCom",
      "GroundIncludeRateID",
      "DisplayAicraftNameOnSearchResult",
      "CompanyReferenceInvoiceRmkReg",
      "CompanyReferenceAlphaRmkReg",
      "RepriceGroupByAccountCode",
      "GroundspanForceMasterCardTypeMC",
      "EnableAtpcoShopping",
      "EnableNdcShopping",
      "EnableLccShopping",
      "DisableFlightSearch",
      "EnableBfmRestFlightSearch",
      "BFMNumberOfTrips",
      "PreferNDCSourceOnTie",
      "RepriceGroupByRefundability",
      "UserDefinedValues",
      "RepriceSingleTicketCarriers",
      "EnableEnhancedLogging",
      "EnableFindMoreFlights",
      "NdcShowIcon",
      "AllowMultiCityInternational",
      "EnableHotelFailureRebook",
      "EnableMultiCityCombined",
      "FlightBookRemovePriceQuotes",
      "ExchangeBookRemovePriceQuotes",
      "EnableRailRestShopping",
      "CarRequestShowButNotAllow",
      "AllowGuestMultiplePassengerPnr",
      "EnableNoExchangeWhenVoidable",
      "RepriceGroupByBrandCarriers",
      "CarDepositCodes",
      "RepriceRailEnabled",
      "EnableSameCrrSplitTktDiffPNRs",
      "SameCrrSplitTktDiffPNRAirlines",
      "RepriceOnewayFaresGroupByCarrier",
      "NdcFareIconText",
      "DisablePaymentPreselectV2",
      "EnableNoSplitNdcBookings",
      "PkgViewToggleText",
      "PkgViewToggleDefaultOn",
      "IncAgyEmailNdcBookingRq",
      "AgyEmailNdcRq",
      "ExchMaxSolutions",
      "ExchKeepOriginalBrand",
      "ExchSingleBrandedFare",
      "ExchIgnoreAllDayForTimeWindow",
      "ExchTimeWindowPlus",
      "ExchTimeWindowMinus",
      "ExchKeepBookingClass",
      "EnableFlightFilterMixedBrands",
      "FilterMixBrandsOnlyCarriers",
      "NoSeatmapCarriers",
      "DisableHotelRefactor",
      "AllowMultiDKCreditCards",
      "HotelMaxPageCount",
      "HotelAvailabilityPageSize",
      "HotelQueryDetailCount",
      "HotelQueryDetailsRatingCount",
      "HotelSlowQueryWarningNumSec",
      "WriteSabreFopUsage",
      "EnableCSPaymentMethods",
      "EnableEnhancedCarBook",
      "EnableCarTravelerEmail",
      "CarBookAcceptablePriceIncrease",
      "FlightDefaultSortingThresholdMin",
      "FlightDefaultSortOrder",
      "GroundspanBookGdsType",
      "EnableCarFopCollectionV2",
      "NdcCarriersContactRefusedIndicator",
      "BFMDirectFlightsPriority",
      "NdcCarriersRequireNotification",
      "EnableFlightPackageResponse",
      "EnableFlightAirportLocationType",
      "NdcExchangeInstantPurchaseCarriers",
      "BFMVendorPrefApplicabilityAtLeastOne",
      "BFMCarrierFilterValidatingCarrier",
      "RepriceDisable",
      "RailPriceAcceptablePriceIncrease",
      "RailPriceAcceptablePriceDecrease",
      "EnableWriteGuestPeNameNumber",
      "FlightSearchTimeFilterDefaultToAll",
      "FlightSearchTimeFilterHide",
      "EnableApprovalUpdateFailOnWarnings",
      "ApprovalUpdateFailBccEmails",
      "MaxFlightSearchConfigurations",
      "EnableExchBookBargainFinderRebook",
      "FlightGstStateCode",
      "FlightSearchLogResultsTimer",
      "EnableHotelFailureRebookModify",
      "EnableMyBookingsQueryV2",
      "AirPointOfSaleCountryCode",
      "AirIsArc",
      "EnableRailCurrentItineraryStops",
      "RepriceNoSplitIntlBookings",
      "HotelSearchGooglePlacesCategoryLimit",
      "RefundAbilityHandlingType",
      "EnableNewSeatMapUi",
      "PostBookingSeatCarriers",
      "EnableHomeSearchV2",
      "EnabledSummaryTravelServices",
      "EnableExpiredRebook",
      "EnablePreTripManageBookingsFeed",
      "EnableManageBookingV2",
      "EnableExchangeShopLogging",
      "GuestTravelerTitleRequired",
      "DisableRecentHotelScores",
      "TripBookingAccountInformation"
    ],
  SuppliersSettingsOptions: ["TravelAgentAccount"],
  PaymentSuppliers: ["Sabre", "Trainline", "EuroStar"],
  CarPolicyTypes: ["Include", "Exclude"],
  DeliveryCollectionSupport: [
    "NotImported",
    "Unknown",
    "DeliveryAvailable",
    "CollectionAvailable",
    "DeliveryAndCollectionAvailable",
  ],
  DurationTypeOptions: [null, "TotalDuration", "AirTimeOnly", "SectorTime"],
  AirportClassificationOptions: ["", "5", "4", "3", "2"],
  RemarkType: ["AlphaCoded", "Historical", "Invoice", "Itinerary"],
  SourceFieldType: ["CompanyRef", "Department", "CostCenter", "ProjectCode"],
  ConditionalApplyTypes: ["OriginDestination", "AnyStopEnRoute"],
  DebtorFopHandlingTypes: ["UseGuarantee", "UseDefined", "NoAction"],
  CarTypeDuplicateHandlingTypes: [
    "ContractOverCheapest",
    "Cheapest",
    "ContractAndNon",
    "ContractAndNonOnlyIfCheaper",
  ],
  CollectionOperationType: ["Count", "None", "Sum", "AllItems", "AtLeastOneItem"],
  OperatorType: [
    "Contains",
    "Equals",
    "GreaterThan",
    "GreaterThanOrEqualTo",
    "LessThan",
    "LessThanOrEqualTo",
    "NotContains",
    "NotEqualTo",
  ],
  ConditionType: [
    "Boolean",
    "Char",
    "DateTime",
    "DateTimeOffset",
    "Decimal",
    "Double",
    "Int32",
    "Int64",
    "Single",
    "String",
  ],
  ActionType: [
    "DisplayMessage",
    "ExcludeFare",
    "ExcludeFromLLF",
    "ForceCreditCard",
    "PnrRemarks",
    "ShowButNotAllow",
    "SetOutOfPolicy",
    "SetInPolicy",
    "MessagePopup",
    "PnrExtraAction",
    "PolicySettings",
    "LimitPassengerPolicy"
  ],
  CardApplicationType: ["Exclude", "Optional", "Only", "ExcludeAllBut"],
  SectorType: ["Air", "Car", "Hotel", "Ground", "Rail"],
  CardSectorType: ["Air", "Car", "Hotel", "Ground", "Rail", "PaidSeats"],
  MessagePlacementType: ["Homepage", "CarResults", "FlightResults", "HotelResults", "GroundResults", "RailResults", "SummaryPage", "SeatMap"],
  FlighLowLogicFareTimeWindowType: ["CompanyTimeWindow", "DefinedTimeWindow"],
  FlighLowLogicFareContractType: ["DoesNotMatter", "ContractCarrierOnly"],
  FlighLowLogicFareStopType: [
    "DoesNotMatter",
    "Fewest",
    "NonStop",
    "Stop1",
    "Stop2",
    "SameOrBetter"
  ],
  RefundabilityOptions: ["DoesNotMatter", "RefundableOnly", "CheapestOnPlane"],
  PlacementType: ['SummaryPage', 'HomeSearch'],
  AgencyVirtualPaymentProviderType: [ 
    { 
      label: "Conferma Pay", 
      value: "ConfermaPay" 
    } 
  ],
  AgencySectorTypes: ["Hotel"],
  AgencyApplyVirtualCreditCardType: [
    {
      label: "Disable",
      value: "Disable"
    },
    {
      label: "Optional",
      value: "Optional"
    },
    {
      label: "Mandatory",
      value: "Mandatory"
    }
  ],
  EnhancedLogsSearchTypes: [
    "PassengerIdentifier",
    "RequestMessage",
    "ResponseMessage",
    "Id",
    "IsError",
    "RequestType",
    "LinkedId"
  ],
  ProcessUploadStatusSearchTypes:[
   "UploadedFilename",
   "UploadedBy",
   "Status",
   "Notes", 
  ],
  VenderPrefRuleProductType:[
   "Hotel",
   "Flight" 
  ],
  VenderPrefAirPrefStopPriority:[
  "NotSet",
   "NonStops",
   "OneStop",
   "TwoStop",
   "ThreeStop"
  ],
  VenderPrefAirPrefSortingType:[
   "PriorityCarrier",
   "DepartureTime",
   "StopCount",
   "Price",
   "Duration"
  ],
  ItineraryPoliciesHotelBenchmarkingBenchmarkAgainst:[
   "Preferred",
    "NonPreferred",
    "LowestAvailable",
    "UseStarRating"
  ],
  ItineraryPoliciesHotelBenchmarkingStarRating: [
    {
      label: "1",
      value: "Rating1"
    },
    {
      label: "2",
      value: "Rating2"
    },
    {
      label: "3",
      value: "Rating3"
    },
    {
      label: "4",
      value: "Rating4"
    },
    {
      label: "5",
      value: "Rating5"
    },
    {
      label: "Equivalent Star Rating",
      value: "Equivalent"
    },
    {
      label: "No Minimum",
      value: "NoMinimum"
    }
  ],
  DebtorMultiPaxPnrHandlingType:[
   "NotAllowed",
   "SingleProfiledWithGuests",
   "AllMultiPassengers",
   "AskOnHomeSearch"
  ],
  PolicyDebtorMultiPaxPnrHandlingType:[
    "DebtorConfiguration",
    "NotAllowed",
    "SingleProfiledWithGuests",
    "AllMultiPassengers",
    "AskOnHomeSearch"
  ],
  HomeSearchDefaultSelectionOptions:[
    "Flight",
    "Hotel",
    "Car",
    "Rail",
    "Ground"
  ],
  ProfileTypes:["TVL","CRP","AGY","AGT","OPX","GRP","ALC"],
  QueueActionTypes:["AutoTicketing","AuthorisationHold","TeamRejection","Cancel","Modification","UserHold","SeatPurchase","AncillaryPurchase"],
  PaidSeatsEnabledType: [
    "DebtorConfiguration", "Yes", "No"
  ],
  DebtorAgentClaimedRemarkHandlingType: ["Debtor", "SystemSettings"],
  FlightCabins:[
    "-","Economy", "PremiumEconomy", "Business", "PremiumBusiness", "First", "PremiumFirst"
  ],
  PassengerTypes:[
  "ADT","GCF","GDP", "GVT", "GVZ", "GST", "SEA"
  ],
  FlightSearchConfigurationQueryItemsType:[
    "Single", "Multi", "Exclude"
  ],
  FlightSearchConfigurationQueryItemsTypeMultiOnly:[
    "Multi"
  ],
  FlightSearchConfigurationType:[
    "Append", "Replace"
  ],
  FlightNdcAtpcoTieSettingsApplicationType:[
    "Inherit", "NotConfigured", "Ndc", "Atpco"
  ],
  FlightNdcAtpcoTieSettingsThresholdType:[
    "Amount", "Percentage"
  ],
  PenaltySearchTypes:[
    "NotSet", "Refundable", "NonRefundable", "Exchangeable", "ExchangeableWithoutPenalty", "RefundableWithoutPenalty", "ExchangeableRefundable", "ExchangeableRefundableWithoutPenalty", "NoVoluntaryChangeInfo"
  ],  
  FlightCorporateRateCodeType: ["SNAP", "BusinessAccountNumber", "CLID", "Qualifier"],
  DebtorIdentificationType: ["LightningConfigDk", "DefinedGroupCode", "DefinedDks"],
  UdidConfigurationType: ["StaticUdid", "CompanyReference", "AgencyReasonCode"],
  PolicyRestrictionType: ["ExcludeFlight", "ShowButNotAllow", "PolicyViolation", "MessagePopup"],
  ProfileAttributeSourceType: ["Sabre", "Elysian"],
  DebtorPolicyGuestTravelType: ["EnableArrangerOnly", "Enable", "Disable"],
  EnableNewUiHandlingType: [
    'SystemSettings',
    'Disabled',
    'Enabled'
  ],
  BoolNullableType: [
    "false",
    "true"
  ],
  DiversityHandlingType: [
    "Dimensions",
    "Parameters",
    "DimensionsAndParameters",
    "None"
  ],
   FlightConfigurationPriority: [
    "DirectFlights",
    "Price",
    "Time",
    "Vendor"
  ],
  TaxDisplayMode:[
    "SystemSettings", "Include", "Exclude"
  ],
};


// WEBPACK FOOTER //
// ./src/config/fieldOptionsConfig.js